var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.333496 0.916992H23.6668V5.08366H0.333496V0.916992Z","fill":"#555555"}));
}

MinusInline.defaultProps = {"width":"24","height":"6","viewBox":"0 0 24 6","fill":"none"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
